<script>
  import Button from "../../Shared/Button.svelte"
  import ChooseBox from "./chooseBox.svelte"
  import BadgeState from "../../Stores/badgeState"
  import notify from "../../../../../Script/notify"
  import { trimSpacesTemplateName } from "../../../File/Edit/Script/tempNamevalidation"
  import ApplicationState from "../../../../../Stores/applicationStates"
  import axios from "axios"
  import { push } from "svelte-spa-router"
  import Palette from "../../Shared/Palette/index.svelte"
  import fileTemplateState from "../../../File/stores/fileTemplateJsonData"
  import { postRequest } from "../../../../../Script/apiMethods"

  export let chooseBoxModal
  export let loader
  let chooseBox = ["300 X 250", "970 X 250", "320 X 50", "250 X 250", "300 X 600", "160 X 600", "200 X 200", "468 X 60", "300 X 1050", "336 X 280", "234 X 60", "120 X 240"]
  let selected = chooseBox[0]
  // defalut or custom size box
  let showChooseBox = true
  let WIDTH_AREA = 100
  let HEIGHT_AREA = 83.33
  let dimensionWidth = 250
  let dimensionHeight = 200
  let aspectRatio

  let closeNotification = {
    close() {},
  }
  let invalidNotification = {
    close() {},
  }

  const updatePreview = (width, height) => {
    try {
      // if (width <= 50) width = 50
      // if (height <= 50) height = 50
      aspectRatio = width / height

      if (aspectRatio > 1) {
        // Width full
        WIDTH_AREA = 100
        HEIGHT_AREA = WIDTH_AREA / aspectRatio
      } else {
        // Height full
        HEIGHT_AREA = 83.33
        WIDTH_AREA = HEIGHT_AREA * aspectRatio
      }
    } catch (error) {
      console.error(error)
      const info = "PAGE: Badge Design Editor\nEVENT: While updating badge area width and height"
      notify.danger(error, info)
    }
  }

  $: if (!showChooseBox) updatePreview(dimensionWidth, dimensionHeight)

  const createBadgeTemp = async () => {
    try {
      closeNotification.close()
      if (!$BadgeState.name || !$BadgeState.name.trim()) throw "Name can't be empty"
      if (!showChooseBox && (!dimensionWidth || !dimensionHeight)) throw "Badge dimensions can't be empty"

      loader = true
      let apiObj = {
        name: $BadgeState.name,
        operations: JSON.stringify($BadgeState.operations),
        bgColour: $BadgeState.canvasColor,
        fonts: JSON.stringify($BadgeState.fonts),
      }

      if (showChooseBox) {
        let arr = selected.split(" X ")
        $BadgeState.baseInfo.width = Number(arr[0])
        $BadgeState.baseInfo.height = Number(arr[1])
      } else {
        $BadgeState.baseInfo.width = dimensionWidth
        $BadgeState.baseInfo.height = dimensionHeight
      }

      apiObj.width = $BadgeState.baseInfo.width
      apiObj.height = $BadgeState.baseInfo.height
      apiObj.file = await createCanvas(apiObj.width, apiObj.height, apiObj.bgColour, apiObj.name)

      // const data = await createBadgeTemplate(apiObj)

      const { template } = await postRequest(`/api/swagger/v2/templates/badges`, apiObj, {
        headers: {
          "x-access-token": $ApplicationState.token,
          "Content-Type": "multipart/form-data",
        },
      })

      $BadgeState.baseInfo.id = template.id

      addTextLayer()
      push(`/templates/badge/edit?id=${template.id}`)
      chooseBoxModal = false
    } catch (error) {
      console.error(error)
      const info = "PAGE: Badge Design Editor\nEVENT: While creating badge template"
      closeNotification = notify.danger(error, info)
    } finally {
      loader = false
    }
  }

  const addTextLayer = () => {
    let textJsonData = {
      id: Date.now(),
      active: true,
      type: "text",
      fontSize: 30,
      fontFamily: "Arial",
      fontWeight: ["Bold"],
      value: "Click to verify",
      // offset: 45,
      letterSpacing: 30,
      radius: 0,
      isRounded: false,
      rotation: 0,
      move: false,
      textColor: $BadgeState.activeTextColor || "#f2072e",
      textAlign: $BadgeState.activeTextAlign || "center",
      x: Math.floor($BadgeState.baseInfo.width / 2),
      y: Math.floor($BadgeState.baseInfo.height / 2),
    }

    // active false applied before layer
    $BadgeState.operations.forEach((operation) => {
      operation.active = false
      operation.textColor ? operation.textColor : "#f2072e"
    })

    // textJsonData.value = `Text ${$BadgeState.operations.length + 1}`
    $BadgeState.operations = [textJsonData, ...$BadgeState.operations]
    $BadgeState.footer = "TEXT"
  }

  /**
   * Converts a canvas element to a Blob object.
   *
   * @param {HTMLCanvasElement} canvas - The canvas element to be converted.
   * @returns {Promise<Blob>} A Promise that resolves with the generated Blob object.
   */
  const canvasToBlob = (canvas) => {
    /**
     * @typedef {Blob} Blob - Represents a binary large object (Blob) that can store binary data.
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Blob Blob}
     */

    return new Promise((resolve) => {
      /**
       * The `toBlob` method of the canvas element is used to convert it to a Blob.
       * @param {Blob} blob - The generated Blob object.
       */
      canvas.toBlob((blob) => {
        // Once the Blob is created, the Promise is resolved with the Blob object.
        resolve(blob)
      }, "image/png")
    })
  }

  const createCanvas = async (width, height, color, name) => {
    try {
      /**
       * @type {HTMLCanvasElement}
       */
      const canvas = document.createElement("canvas")
      /**
       * @type {CanvasRenderingContext2D}
       */
      const ctx = canvas.getContext("2d")
      canvas.width = width
      canvas.height = height

      if (color.startsWith("linear-gradient")) {
        // Extract the angle and colors from the linear-gradient string
        const linearGradientRegex = /linear-gradient\((\d+)deg, (.+)\)/
        const match = color.match(linearGradientRegex)

        if (!match) return

        const angle = parseInt(match[1])
        const colorStops = match[2].split(",")

        // Calculate the end coordinates for the gradient based on the angle
        const radians = (angle * Math.PI) / 180
        const x1 = canvas.width * Math.cos(radians)
        const y1 = canvas.height * Math.sin(radians)

        // Create the linear gradient
        const gradient = ctx.createLinearGradient(0, 0, x1, y1)

        // Add color stops (strip percentages from color strings)
        colorStops.forEach((stop, index) => {
          const cleanedStop = stop.trim().replace(/ \d+%$/, "") // Remove percentage
          gradient.addColorStop(index / (colorStops.length - 1), cleanedStop)
        })

        // Apply the gradient to the canvas
        ctx.fillStyle = gradient
        ctx.fillRect(0, 0, width, height)
      } else if (color != "transparent") {
        ctx.fillStyle = color
        ctx.fillRect(0, 0, width, height)
      }

      let blobObject = await canvasToBlob(canvas)
      // Create a new File object with the Blob and provide a default filename and type
      let file = new File([blobObject], `${name + "-" + Date.now()}.png`, {
        type: "image/png",
      })

      return file
    } catch (error) {
      throw error
    }
  }

  /**
   * Regular expression pattern for allowed characters.
   * Matches any combination of uppercase letters, lowercase letters, digits, spaces, hyphens, parentheses, plus signs, ampersands, and periods.
   * @type {RegExp}
   */
  const allowedCharsRegex = /^[A-Z\d\s-()+&.]*$/i

  const checkSpecialChars = (e, name) => {
    // Close any existing notifications
    invalidNotification.close()

    const info = "PAGE: Badge Template Editor (Init Modal)\nEVENT: Validating invalid characters for the badge template name during onBlur/ onPaste/ onKeypress"

    // Destructure the type and key properties from the event object
    let { type, key } = e

    // Check if it's a keypress event and the pressed key is not allowed

    if (type === "keypress" && !allowedCharsRegex.test(key)) {
      // Ensure the name property is initialized as a string
      if (typeof $BadgeState.name !== "string") {
        $BadgeState.name = "" // Initialize it as an empty string
      }

      // Temporarily append the invalid key
      $BadgeState.name += key

      // Prevent the default keypress behavior
      e.preventDefault()

      // Show a danger notification
      invalidNotification = notify.danger("Only <strong>Letters</strong>,<strong>Numbers</strong> and <strong>-()+.&</strong> are allowed.", info)

      setTimeout(() => {
        // Remove the last invalid character
        $BadgeState.name = $BadgeState.name.slice(0, -1)
      }, 100)
    } else if (type === "paste" || type === "blur") {
      // Prevent the default paste behavior
      // e.preventDefault()
      let pastedText

      if (type === "blur") {
        pastedText = $BadgeState.name
      } else {
        // Get the pasted text from the clipboard
        let clipboardData = e.clipboardData || window.clipboardData
        pastedText = clipboardData.getData("text/plain")
      }

      // Set the input value to the pasted text
      name = pastedText

      setTimeout(() => {
        // Remove any characters that are not letters, spaces, or specified special characters
        // let sanitizedText = pastedText.replace(new RegExp(`[^A-Z_\\-\\s\\d()+₹.]`, "gi"), "").trim()
        // Set the input value to the sanitized text
        // name = checkMaxCharacters(name)
        // Show a danger notification indicating the allowed characters and the removed non-specified characters

        if (!allowedCharsRegex.test(pastedText)) {
          let sanitizedText = pastedText.replace(/[^A-Za-z0-9\s-()+&.]/g, "").trim()
          if (sanitizedText !== pastedText) {
            invalidNotification = notify.danger("Only <strong>Letters</strong>, <Strong>Numbers</strong> and <br/> <strong>-()+.&</strong> are allowed. Removing non-specified Characters", info)
          }
          $BadgeState.name = sanitizedText
        }

        checkMaxCharacters()
        // $BadgeState.name = checkMaxCharacters($BadgeState.name)
        // $BadgeState.name = name
      }, 500)
    }
  }
  /**
   * @type {Number} - maximum character count for template name
   */
  let maxCharacters = 25

  const checkMaxCharacters = () => {
    //Deleting existing notification
    closeNotification.close()

    // ...
    if ($BadgeState.name && $BadgeState.name.length >= maxCharacters) {
      // Displaying notification for exceeding maximum characters
      closeNotification = notify.info(`Template name should not be more than ${maxCharacters} characters`)

      // Setting a timer to slice the name to maxCharacters
      setTimeout(() => {
        $BadgeState.name = $BadgeState.name.slice(0, maxCharacters)
      }, 20)
    }
  }

  const preventKeys = (e) => {
    const KEYS_TO_PREVENT = ["-", "+", "e", "E"]
    if (KEYS_TO_PREVENT.includes(e.key)) e.preventDefault()
  }

  const checkWidth = () => {
    try {
      if (dimensionWidth < 50) {
        dimensionWidth = 50
        throw `Minimum Width must be 50px`
      } else if (dimensionWidth > 1200) {
        dimensionWidth = 1200
        throw `Maximum Width must be 1200px`
      }
    } catch (error) {
      closeNotification.close()
      const info = "Badge Design Editor\nEVENT: While validating badge area width onBlur"
      closeNotification = notify.danger(error, info)
    }
  }

  const checkHeight = () => {
    try {
      if (dimensionHeight < 50) {
        dimensionHeight = 50
        throw `Minimum Height must be 50px`
      } else if (dimensionHeight > 1200) {
        dimensionHeight = 1200
        throw `Maximum Height must be 1200px`
      }
    } catch (error) {
      closeNotification.close()
      const info = "Badge Design Editor\nEVENT: While validating badge area height onBlur"
      closeNotification = notify.danger(error, info)
    }
  }
</script>

<div class="fixed inset-0 z-20 overflow-y-auto rounded-md bg-[#000000cc] backdrop-blur-md transition-opacity">
  <div class="flex h-full flex-col items-center justify-center p-10">
    <form on:submit|preventDefault={createBadgeTemp} class="w-full max-w-[490px]">
      <div class="flex w-full flex-col gap-6 rounded-t-md bg-darkgray p-6 text-[#A7A7A7]">
        <!-- {#if showLoader} -->
        <!-- {:else} -->
        <span class="text-center text-xl font-bold">Creating a New Badge Design Template</span>

        <div class="flex h-[300px] flex-wrap justify-between overflow-y-scroll {showChooseBox ? '' : 'items-center gap-5'}">
          <!-- Choose default size -->
          {#if showChooseBox}
            {#each chooseBox as singleBox}
              <ChooseBox
                {singleBox}
                active={selected}
                on:click={() => {
                  selected = singleBox
                }}
              />
            {/each}
          {:else}
            <!-- Enter custom size -->
            <div class="flex w-full items-center gap-3">
              <div class="flex w-1/2 flex-col items-center gap-6">
                <div class="group relative flex w-full items-center gap-3 rounded-md">
                  <span class="w-2/5 select-none text-right text-lg text-extraBlue-500">Width</span>
                  <div class="group relative w-full rounded-md">
                    <input min="50" on:keypress={preventKeys} on:blur={checkWidth} bind:value={dimensionWidth} type="number" class="w-full select-none rounded-md border border-extraBlue-500 bg-transparent py-2 pl-3 pr-8 text-sm text-extraBlue-500 outline-none placeholder:text-gray-700 focus:ring-1 focus:ring-extraBlue-500" placeholder="Enter Width" on:input={() => updatePreview(dimensionWidth, dimensionHeight)} />
                  </div>
                </div>
                <div class="group relative flex w-full items-center gap-3 rounded-md">
                  <span class="w-2/5 select-none text-right text-lg text-extraBlue-500">Height</span>
                  <div class="group relative w-full rounded-md">
                    <input on:keypress={preventKeys} min="50" bind:value={dimensionHeight} on:blur={checkHeight} type="number" class="w-full select-none rounded-md border border-extraBlue-500 bg-transparent py-2 pl-3 pr-8 text-sm text-extraBlue-500 outline-none placeholder:text-gray-700 focus:ring-1 focus:ring-extraBlue-500" placeholder="Enter Height" on:input={() => updatePreview(dimensionWidth, dimensionHeight)} />
                  </div>
                </div>
              </div>

              <!-- Preview -->
              <div class="flex w-1/2 flex-col items-center justify-center gap-1">
                <div class="flex h-32 w-32 flex-col items-center justify-center rounded-md border-4 border-orange-500 bg-gray-a00 hover:border-orange-600">
                  <div style="width: {WIDTH_AREA}px;height:{HEIGHT_AREA}px;background:{$BadgeState.canvasColor == 'transparent' ? 'url("assets/img/grid.png")' : `${$BadgeState.canvasColor}`};" class="rounded" />
                </div>
              </div>
            </div>
          {/if}
        </div>
        <div class="w-full rounded-md">
          <Palette bind:headerBackground={$BadgeState.canvasColor} colorCount={17} disableGradient={false} BtnName="Choose Background Color" position="bottom" />
        </div>
        <div class="group relative w-full rounded-md">
          <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 {$BadgeState.name ? 'group-focus-within:text-extraBlue-500' : 'group-focus-within:text-red-500'}">NAME</div>
          <!-- on:blur={checkSpecialChars} -->

          <input
            on:blur={() => {
              $BadgeState.name = trimSpacesTemplateName($BadgeState.name)
            }}
            on:blur={checkSpecialChars}
            on:paste={checkSpecialChars}
            on:keypress={checkSpecialChars}
            on:keypress={checkMaxCharacters}
            type="text"
            bind:value={$BadgeState.name}
            required
            placeholder="Enter template name"
            class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-16 text-sm text-white outline-none invalid:animate-shake invalid:border-red-500 focus:ring-2 focus:ring-extraBlue-500 focus:invalid:ring-red-500"
          />
        </div>
      </div>
      <div class="flex w-full flex-col items-center justify-between gap-3 rounded-b-md bg-[#242424] p-6 text-[#A7A7A7] mobile:flex-row">
        <Button type="button" on:click text="Close" iconClass="fa-circle-xmark" addClass="bg-red-500" />
        <Button
          type="button"
          on:keydown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault() // Prevent triggering click event
            }
          }}
          on:click={(e) => {
            if (e.detail === 0) return // Ignore keyboard-triggered clicks

            showChooseBox = !showChooseBox
            let arr = selected.split(" X ")
            dimensionWidth = Number(arr[0])
            dimensionHeight = Number(arr[1])
            // createBadgeTemp()
          }}
          text={showChooseBox ? "Custom Size" : "Back to List"}
          iconClass={showChooseBox ? "fa-rotate-reverse" : "fa-list"}
          addClass={showChooseBox ? "bg-blue-500" : "bg-sky-500"}
        />

        <Button type="submit" state={!$BadgeState.name} text="Create" iconClass="fa-pen-to-square" addClass="bg-green-500" />
      </div>
    </form>
  </div>
</div>
